import { Tabs } from "@mantine/core";
import BlogCategoryManager from "./BlogCategoryManager";
import BlogPostManager from "./BlogPostManager";

const BlogManager = () => {
  return (
    <Tabs>
      <Tabs.List>
        <Tabs.Tab value="posts">Posts</Tabs.Tab>
        <Tabs.Tab value="categories">Categories</Tabs.Tab>
      </Tabs.List>
      
      <Tabs.Panel value="posts">
        <BlogPostManager />
      </Tabs.Panel>
      
      <Tabs.Panel value="categories">
        <BlogCategoryManager />
      </Tabs.Panel>
    </Tabs>
  );
};

export default BlogManager;
